import { useMemo } from "react";
import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../constants/queryKeys";
import accountService from "../../services/accountService";
import stringUtils from "../../utils/stringUtils";

const useAccountAdminSites = ({ childExternalIds }) => {
  // Callers pass `[...(childExternalIds || []), account?.externalId]`, so before
  // an account is selected this is `[undefined]` — length 1 but no real ids.
  // Without compacting we'd request `/Account/Admin?externalIds=` and get a 401.
  const externalIds = useMemo(
    () => stringUtils.compactList(childExternalIds),
    [childExternalIds?.join(",")]
  );

  return useQuery(
    [
      queryKeys.accountSites,
      externalIds.join(","),
      "admin",
    ],
    () =>
      accountService.fetchAccountsForAdmin({
        accountExternalIds: externalIds,
      }),
    {
      enabled: externalIds.length > 0,
      staleTime: Infinity,
    }
  );
};

export default useAccountAdminSites;
